<template>
  <div class="bankinfo">
    <toptitle :title1="titlework" />
    <p class="blank">工资账号</p>
    <van-cell-group>
      <van-field
        v-model="account_ec_id"
        label="账号"
        placeholder="请输入"
        required
        clearable
      />
      <van-field
        v-model="account_name_ac"
        label="户名"
        placeholder="请输入"
        required
        clearable
      />
      <section class="provesec">
        <div class="bank">
          <span>*</span>银行
        </div>
        <div class="arrow">
          <van-cell is-link @click="showPopup2">{{ bank_cd }}</van-cell>
          <van-popup v-model="show2">
            <van-picker
              title="请选择银行"
              show-toolbar
              :columns="columns"
              @confirm="onConfirm2"
              @cancel="onCancel"
            />
          </van-popup>
        </div>
      </section>
      <van-field
        v-model="account_name"
        label="开户行"
        placeholder="请输入"
        required
        clearable
      />
    </van-cell-group>

    <p class="blank">固定收益账号</p>

    <van-cell-group>
      <van-field
        v-model="account_ec_id1"
        label="账号"
        placeholder="请输入"
        clearable
      />
      <van-field
        v-model="account_name_ac1"
        label="户名"
        placeholder="请输入"
        clearable
      />
      <section class="provesec">
        <div >
          <span>银行</span>
        </div>
        <div class="arrow">
          <van-cell is-link @click="showPopup">{{ bank_cd1 }}</van-cell>
          <van-popup v-model="show">
            <van-picker
              title="请选择银行"
              show-toolbar
              :columns="columns"
              @confirm="onConfirm"
              @cancel="onCancel"
            />
          </van-popup>
        </div>
      </section>
      <van-field
        v-model="account_name1"
        label="开户行"
        placeholder="请输入"
        clearable
      />
    </van-cell-group>

    <div class="button-bt">
      <div @click="submit">提交</div>
      <div @click="cancel">取消</div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import toptitle from "../../components/toptitle";
import { changeDataApi, changeResumeDataApi } from "../../request/api";
import * as dd from "dingtalk-jsapi"; // 此方式为整体加载，也可按需进行加载
import dateformat from "@/utils/dateformat";
import isempty from "@/utils/isempty";
export default {
  data() {
    name: "bankinfo";
    return {
      titlework: "编辑银行信息",
      bankArr: [],
      paramData: null,
      show: false,
      show2: false,
      columns: [],
      account_ec_id: "", //this.$route.query.paramData.ACCOUNT_EC_ID,
      account_name_ac: "", //this.$route.query.paramData.ACCOUNT_NAME_AC,
      account_name: "", //this.$route.query.paramData.ACCOUNT_NAME,
      bank_cd: "", //this.$route.query.paramData.BANK_CD,

      account_ec_id1: "", //this.$route.query.paramData.ACCOUNT_EC_ID1,
      account_name_ac1: "", //this.$route.query.paramData.ACCOUNT_NAME_AC1,
      account_name1: "", //this.$route.query.paramData.ACCOUNT_NAME1,
      bank_cd1: "", //this.$route.query.paramData.BANK_CD1,
    };
  },
  methods: {
    onCancel() {
      this.show = false;
      this.show2 = false;
    },
    showPopup() {
      this.show = true;
    },
    onConfirm(value) {
      this.bank_cd1 = value;
      this.show = false;
    },
    showPopup2() {
      this.show2 = true;
    },
    onConfirm2(value) {
      this.bank_cd = value;
      this.show2 = false;
    },
    cancel() {
      this.$router.push("/resume");
    },
    submit() {
      if (isempty(this.account_ec_id)) {
        this.$toast("账号不能为空");
        return false;
      }
      if (isempty(this.account_name_ac)) {
        this.$toast("户名不能为空");
        return false;
      }
      if (isempty(this.bank_cd)) {
        this.$toast("银行不能为空");
        return false;
      }
      if (isempty(this.account_name)) {
        this.$toast("开户行不能为空");
        return false;
      }
      let bank_cd = this.bank_cd;
      let bank_cd1 = this.bank_cd1;
      for (let i = 0; i < this.bankArr.length; i++) {
        if (this.bank_cd == this.bankArr[i].XLATSHORTNAME) {
          bank_cd = this.bankArr[i].FIELDVALUE;
        }
        if (this.bank_cd1 == this.bankArr[i].XLATSHORTNAME) {
          bank_cd1 = this.bankArr[i].FIELDVALUE;
        }
      }
      let params = {
        security: {
          signTxt: "OTQ5QKE3NJJFNDQ0Q0JFM0JDNURDNJM2MTG4NKIWQJM3=",
          ipAddress: "10.19.185.14",
          system: "SELF",
          pubkeyRmk: "Z7PCKFDMBPVHGS0ZGDQT",
        },
        parameters: {
          TYPE: "4", //银行信息
          EMPLID: sessionStorage.getItem("EMPLID"),
          DATE: dateformat("yyyy-MM-dd"),

          ACCOUNT_EC_ID: this.account_ec_id,
          ACCOUNT_NAME_AC: this.account_name_ac,
          ACCOUNT_NAME: this.account_name,
          BANK_CD_ID: bank_cd,

          ACCOUNT_EC_ID1: this.account_ec_id1,
          ACCOUNT_NAME_AC1: this.account_name_ac1,
          ACCOUNT_NAME1: this.account_name1,
          BANK_CD_ID1: bank_cd1,
        },
      };
      changeResumeDataApi(params).then((res) => {
        console.log(res);
        if (res.CODE == 1) {
          Toast.success("提交成功");
          this.$router.back(-1);
        } else {
          Toast.fail(res.MESSAGE);
        }
      });
    },
  },
  components: {
    toptitle,
  },
  created() {
    console.log("日期", dateformat("yyyy-MM-dd"));

    this.paramData = this.$route.query.paramData;
    if (!this.paramData) {
      this.paramData = {
        ACCOUNT_EC_ID: "",
        ACCOUNT_NAME_AC: "",
        ACCOUNT_NAME: "",
        BANK_CD: "",
        ACCOUNT_EC_ID1: "",
        ACCOUNT_NAME_AC1: "",
        ACCOUNT_NAME1: "",
        BANK_CD1: "",
      };
    }
    this.account_ec_id = this.paramData[0].ACCOUNT_EC_ID;
    this.account_name_ac = this.paramData[0].ACCOUNT_NAME_AC;
    this.account_name = this.paramData[0].ACCOUNT_NAME;
    this.bank_cd = this.paramData[0].BANK_CD;

    this.account_ec_id1 = this.paramData[0].ACCOUNT_EC_ID1;
    this.account_name_ac1 = this.paramData[0].ACCOUNT_NAME_AC1;
    this.account_name1 = this.paramData[0].ACCOUNT_NAME1;
    this.bank_cd1 = this.paramData[0].BANK_CD1;
    let params = {
      FIELDNAME: "C_BANK",
    };
    changeDataApi(params).then((res) => {
      if (res.RESULTCODE == 1) {
        this.bankArr = res.DATA;
        this.columns = this.bankArr.map((index) => {
          return index.XLATSHORTNAME;
        });
      }
    });
  },
};
</script>

<style lang="less" scoped>
.provesec {
  display: flex;
  line-height: 44px;
  background: white;
  padding-left: 16px;
  .arrow {
    flex: 1;
    text-align: right;
    line-height: 44px;
    color: #c4c4c6;
  }
  .bank{
    position: relative;
    right: 7px;
    span{
    position: relative;
    right: 1px;
    color: #ee0a24;
  }
  }
}
/deep/ .van-cell__value {
  text-align: right;
}
/deep/ .van-popup {
  width: 80%;
}
/deep/ .van-cell__title {
  font-size: 16px;
  color: black;
}
/deep/ input.van-field__control {
  text-align: right;
}
.blank {
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  padding: 0 16px;
  color: #888888;
}
.button-bt {
  position: fixed;
  bottom: 0;
  display: flex;
  line-height: 44px;
  text-align: center;
  color: white;
  width: 100%;
  div {
    background: #733e2a;
    width: 50%;
    font-size: 17px;
  }
}
</style>
